import inventoryAPI from '@/services/api/inventory'
import { ReasonType } from '@/utils/defines/ItemCode'

const InputUsage = {
	namespaced: true,
	state: () => ({
		volume: 0,
		volumeUnit: undefined,
		currentVolume: undefined,
		unitList: undefined,
	}),
	getters: {
		getUnitListKeys: state =>
			state.unitList ? [...Object.keys(state.unitList)] : [],
	},
	mutations: {
		setVolume: (state, payload) => {
			state.volume = payload
		},
		setVolumeUnit: (state, payload) => {
			state.volumeUnit = payload
		},
		setCurrentVolume: (state, payload) => {
			state.currentVolume = payload
		},
		setUnitList: (state, payload) => {
			state.unitList = payload
		},
	},
	actions: {
		loadUnit: ({ commit, state }, payload) => {
			return new Promise(async (resolve, reject) => {
				const response = await inventoryAPI.getUnit(payload)
				commit('setUnitList', response.data)
				resolve(response.data)
			})
		},
		completeUsage: async ({ commit }, payload) => {
			const {
				type,
				changeVolumeUnit,
				changeVolume,
				instId,
				itemsIds,
				memo,
			} = payload

			let usageData
			switch (type) {
				case ReasonType.ITEM_RETURN:
					usageData = {
						itemsId: itemsIds,
						memo: memo,
						changeVolume: -changeVolume,
						changeVolumeUnit: changeVolumeUnit,
					}
					await inventoryAPI.returnItem(instId, usageData)
					payload.this.$notify({
						type: 'common',
						text: tt('물품이 반납되었습니다 [사용량:${1}]', `${changeVolume}${changeVolumeUnit}`),
					})

					payload.this.$notify({
						type: 'common',
						text: tt('물품이 사용완료되었습니다'),
					})
					break
				case ReasonType.ITEM_CONSUME:
					usageData = {
						id: itemsIds[0],
						memo: memo,
						changeVolume: -changeVolume,
						changeVolumeUnit: changeVolumeUnit,
					}
					await inventoryAPI.consumeItem(instId, usageData)
					payload.this.$notify({
						type: 'common',
						text: tt('사용량이 입력되었습니다 [사용량:${1}]', `${changeVolume}${changeVolumeUnit}`),
					})
					break
			}

			payload.this.$router.go(-1)
		},
	},
}
export default InputUsage
